import { getRequest, postRequest } from '@/api/request';

export const getArchitectureTree = async ({ includeDrafts = false } = {}) => getRequest({
  url: includeDrafts
    ? '/jobprofile/architecture/tree?include_drafts=true'
    : '/jobprofile/architecture/tree',
});

export const fetchJobFamilies = async () => getRequest({ url: '/jobprofile/architecture/families' });

export const fetchJobFamilyGroups = async () => getRequest({ url: '/jobprofile/architecture/family-groups' });

export const getProfilesByUlids = async (ulids) => {
  const listOfUlids = Array.isArray(ulids) ? ulids : [];
  const params = new URLSearchParams();

  listOfUlids.forEach((ulid) => params.append('ulids[]', ulid));

  return getRequest({ url: `/jobprofile/architecture/profiles?${params.toString()}` });
};

export const bulkUpdateProfileFamily = async ({ ulids, familyUlid }) => postRequest({
  url: '/jobprofile/architecture/bulk-update-profile-family',
  body: { ulids, family_ulid: familyUlid },
});

export const bulkRemoveProfilesFromFamily = async ({ ulids }) => postRequest({
  url: '/jobprofile/architecture/bulk-remove-profile-family',
  body: { ulids },
});

export const createJobFamilyGroup = async ({ name }) => postRequest({
  url: '/jobprofile/architecture/create-family-group',
  body: { name },
});

export const createJobFamily = async ({ name, groupUlid }) => postRequest({
  url: '/jobprofile/architecture/create-family',
  body: { name, group_ulid: groupUlid },
});

export const updateJobFamilyGroupName = async ({ ulid, name }) => postRequest({
  url: '/jobprofile/architecture/rename-group',
  body: { ulid, name },
});

export const updateJobFamilyName = async ({ ulid, name }) => postRequest({
  url: '/jobprofile/architecture/rename-family',
  body: { ulid, name },
});

export const updateJobFamilyGroup = async ({ familyUlid, fromGroupUlid, toGroupUlid }) => postRequest({
  url: '/jobprofile/architecture/move-family',
  body: {
    family_ulid: familyUlid,
    from_group_ulid: fromGroupUlid,
    to_group_ulid: toGroupUlid,
  },
});

export const deleteJobFamily = async ({ ulid }) => postRequest({
  url: '/jobprofile/architecture/delete-family',
  body: { ulid },
});

export const fetchJobFamilyDraftCount = async ({ ulid }) => getRequest({
  url: `/jobprofile/architecture/family-draft-count?ulid=${encodeURIComponent(ulid)}`,
});
